import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import DeleteEmailUrlModal from "routes/email_urls/components/DeleteEmailUrlModal";
import { EMAIL_URLS_PATH } from "routes/email_urls/components/email_urls_table/EmailUrlsTableV3";

const EDIT_ACLS = [ACL_RELATIONSHIPS.emailUrl.edit];
const DELETE_ACLS = [ACL_RELATIONSHIPS.emailUrl.delete];
const ANY_ACLS = [...EDIT_ACLS, ...DELETE_ACLS];

export function EmailUrlsTableActions({ original }) {
  const navigate = useNavigate();
  const [deleteOpen, setDeleteOpen] = useState(false);

  return (
    <Authorized permissions={ANY_ACLS} partialMatch>
      <>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="Email URL actions"
            className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
          >
            <Ellipsis />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="tw:w-auto">
            <Authorized permissions={EDIT_ACLS}>
              <DropdownMenuItem
                onClick={() =>
                  navigate(`${EMAIL_URLS_PATH}/${original.id}/edit`)
                }
              >
                <Pencil />
                Edit
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={DELETE_ACLS}>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setDeleteOpen(true)}
              >
                <Trash2 />
                Archive
              </DropdownMenuItem>
            </Authorized>
          </DropdownMenuContent>
        </DropdownMenu>
        <Authorized permissions={DELETE_ACLS}>
          <DeleteEmailUrlModal
            emailUrlId={original.id}
            open={deleteOpen}
            onOpenChange={setDeleteOpen}
          />
        </Authorized>
      </>
    </Authorized>
  );
}
